import { getVariableTarget, setEditorTarget, setInputTarget } from './variableTargetStore';

// Inserts a variable at the last saved caret position (content editor or a
// subject input), not at whatever is focused when the `+` is clicked.
export function insertVariable(mapping) {
  const text = mapping || '';
  if (!text) return;

  const target = getVariableTarget();
  if (!target) return;

  if (target.type === 'editor') {
    const editor = window.tinymce?.activeEditor;
    if (!editor) return;
    editor.selection.moveToBookmark(target.bookmark);
    editor.insertContent(text);
    // Re-capture the caret so it now sits after the inserted text.
    setEditorTarget(editor);
    return;
  }

  if (target.type === 'input') {
    const el = target.el;
    if (!el || !document.contains(el)) return;
    el.focus();
    el.setSelectionRange(target.start, target.end);
    // execCommand keeps React's controlled value in sync (fires an input event)
    // and pushes a native undo step.
    document.execCommand('insertText', false, text);
    setInputTarget(el);
  }
}
